import styled from "styled-components";

export const Container = styled.span`
  color: #585f74;
  margin-bottom: 8px;
  font-size: 12px;
  font-weight: 600;
`;
